import React, { Component } from "react";

import { Measurement as MeasurementInput } from "../../form-inputs/inputs";

class MeasurementExamples extends Component {
    constructor(props) {
        super(props);
        this.state = {
            measurement: {
                value: "1",
                uom: "ft",
            },
        };
    }

    measurementChange = (value) => {
        this.setState({
            measurement: value,
        });
    };

    render() {
        return (
            <div>
                <MeasurementInput name="measurement" label="Measurement" filter={["nutrient"]} value={this.state.measurement.uom} updateOnChange={this.measurementChange} />
            </div>
        );
    }
}

export default MeasurementExamples;
